export enum OrderEvents {
  RetailerNextClicked = 'checkout_retailer_next',
  ConfirmClicked = 'checkout_confirm_tap',
  CheckoutConfirmBackTap = 'checkout_confirm_back_tap',
  CheckoutSignDocuments = 'checkout_sign_docs',
  CheckoutGotoCatalog = 'checkout_goto_catalog',
  CheckoutOrderListTap = 'checkout_goto_my_orders_tap',
}
